// src/pages/AboutPage.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../styles/AboutPage.css';

export default function AboutPage() {
  return (
    <main className="about-us">
      <Helmet>
        <title>About Us – Typing Test</title>
        <meta 
          name="description" 
          content="Learn about Typing Test, a platform dedicated to improving your typing speed and accuracy with various tests and insightful analytics." 
        />
      </Helmet>
      <div className="container">
        <h1>About Us</h1>
        <p>Welcome to Typing Test, your number one source for improving your typing skills. We're dedicated to providing you the very best of typing tests, with an emphasis on speed, accuracy, and a variety of test durations.</p>
        <h2>Our Mission</h2>
        <p>Our mission is to make typing practice fun and effective. We aim to help people of all ages enhance their typing speed and accuracy through engaging and easy-to-use tests.</p>
        <h2>Our Features</h2>
        <ul>
          <li><strong>Easy Analytics:</strong> Track your progress with simple and intuitive analytics.</li>
          <li><strong>Unlimited Practice:</strong> Take as many tests as you like to continuously improve your skills.</li>
          <li><strong>Instant Feedback:</strong> Receive immediate feedback on your typing performance.</li>
          <li><strong>Flexible Time Limits:</strong> Choose from a variety of test durations to suit your needs and goals.</li>
        </ul>
        <h2>Our Vision</h2>
        <p>We envision a world where everyone can type efficiently and effectively, making communication faster and more productive. Whether you're a student, a professional, or someone looking to improve their typing skills, Typing Test is here to support you on your journey.</p>
        <h2>Contact Us</h2>
        <p>If you have any questions or suggestions, feel free to reach out to us at <a href="mailto:spicypepper69@protonmail.com">spicypepper69@protonmail.com</a>. We're always here to help!</p>
      </div>
    </main>
  );
}
